import { api } from "./api";
import * as endpoints from "../data/links/endpoints";

export async function getExercises({ signal }) {
  return api
    .get(endpoints.EXERCISES, { signal })
    .then((res) => res.data.exercises)
    .catch((error) => error.response);
}

export async function getExcludedExercises({ signal }) {
  return api
    .get(endpoints.GET_EXCLUDED_EXERCISES, { signal })
    .then((res) => res.data.exercises)
    .catch((error) => error.response);
}

export async function getExercisesByCategory({ equipment, categoryId }) {
  let body = {
    equipment,
    category_id: categoryId,
  };
  return api.post(endpoints.EXERCISE_FILTER, body).then((res) => res);
}

export async function getPerformanceExercises({ categoryId, signal }) {
  return api
    .get(endpoints.GET_PERFORMANCE_EXERCISES + categoryId, { signal })
    .then((res) => res.data.exercises)
    .catch((error) => error.response);
}

export async function getExerciseStatistics(data) {
  let { exerciseId, distance, category, score } = data;
  if (!exerciseId) return;

  let body = {
    score,
    category,
    exercise_id: exerciseId,
  };
  // body.append("category", category);
  // body.append("exercise_id", exerciseId);
  // body.append("score", score);

  if (category === "cardio") body["distance"] = distance;

  return api.post(endpoints.GET_EXERCISE_STATS, body).then((res) => res);
}

export async function getScaling({ signal }) {
  return api
    .get(endpoints.GET_SCALING, { signal })
    .then((res) => res.data.scaling)
    .catch((error) => error.response);
}

export async function getRecentProgress({ type, signal }) {
  return api
    .get(endpoints.GET_RECENT_EXERCISE_PROGRESS + type, { signal })
    .then((res) => res.data.data)
    .catch((error) => error.response);
}
